var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-title" }, [
    _c("div", { staticClass: "col-md-6 offset-md-3 mb-5" }, [
      _c("div", [
        _c("h1", { staticClass: "h-title" }, [
          _vm._m(0),
          _c("span", [_vm._v(_vm._s(_vm.officename) + " 履歴書送信システム")])
        ]),
        _vm._m(1)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        attrs: { src: require("../assets/images/logo.png"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "contents-introduction" }, [
      _vm._v("案内に沿ってフォームに入力するだけで、"),
      _c("br"),
      _vm._v(
        "PDFファイルのJIS規格に合わせた履歴書が作成できる自動作成ツールです。"
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }